import { render } from "./ordertakenlist.vue?vue&type=template&id=3e022705"
import script from "./ordertakenlist.vue?vue&type=script&lang=js"
export * from "./ordertakenlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__